import XLSX from 'xlsx-js-style';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import formatCompleteDate from '../formatCompleteDate';

function getOrderScheduled(orders) {
  orders = orders?.data?.sessions ?? [];

  const sortedOrders = orders.sort((a, b) => {
    const dateA = new Date(a.scheduled_to);
    const dateB = new Date(b.scheduled_to);
    return dateA - dateB;
  });

  const headers = [
    'Data de Entrega',
    'Cliente',
    'Telefone',
    'Endereço',
    'Retirada/Entrega',
    'Itens para Produção',
    'Observação',
    'Valor (R$)',
  ];

  const data = [headers];

  let prevDate = null;

  sortedOrders.forEach((o) => {
    const currentDate = o.scheduled_to;

    const currentDateOnly = new Date(currentDate).toDateString();
    const prevDateOnly = prevDate ? new Date(prevDate).toDateString() : null;

    if (prevDateOnly !== null && prevDateOnly !== currentDateOnly) {
      // Adiciona linha vazia como separadora
      data.push(new Array(8).fill(''));
    }

    data.push([
      formatCompleteDate(o.scheduled_to),
      o.buyer.name,
      o.buyer.phone,
      o.buyer_address !== null
        ? `${o.buyer_address?.street}, ${o.buyer_address?.number}`
        : 'Sem endereço',
      o.with_withdrawal === true ? 'Retirada' : 'Entrega',
      o.orders
        .map((o) => {
          const complements = (o.complement_categories || [])
            .flatMap((ctg) =>
              (ctg.complements || []).map(
                (apc) => ` - ${apc.amount} ${apc.name}`
              )
            )
            .join('\n');
          return complements
            ? `${o.amount}x ${o.product_name}\n${complements}`
            : `${o.amount}x ${o.product_name}`;
        })
        .join('\n'),
      o.details,
      `R$ ${o.total_delivery_price}`,
    ]);
    prevDate = currentDate;
  });

  return data;
}

export function generateSheet(orders) {
  const rows = getOrderScheduled(orders);

  const num_cols = 8;

  const workbook = XLSX.utils.book_new();
  const worksheet = XLSX.utils.aoa_to_sheet(rows);

  worksheet['!cols'] = new Array(num_cols);
  worksheet['!cols'].fill({ wch: 25 });

  const range = XLSX.utils.decode_range(worksheet['!ref']);

  const borderStyle = {
    top: { style: 'thin', color: { rgb: '000000' } },
    left: { style: 'thin', color: { rgb: '000000' } },
    bottom: { style: 'thin', color: { rgb: '000000' } },
    right: { style: 'thin', color: { rgb: '000000' } },
  };

  for (let R = 0; R <= range.e.r; ++R) {
    const isHeader = R === 0;
    const isEmptyRow = rows[R] && rows[R].every((cell) => cell === '');

    for (let C = 0; C < num_cols; ++C) {
      const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });

      // Se a célula não existe, cria vazia
      if (!worksheet[cell_ref]) {
        worksheet[cell_ref] = { t: 's', v: '' };
      }

      if (isHeader) {
        // Cabeçalho
        worksheet[cell_ref].s = {
          font: { bold: true, sz: 12 },
          fill: { fgColor: { rgb: 'F8CCCC' } },
          alignment: { horizontal: 'center', vertical: 'center' },
          border: borderStyle,
        };
      } else if (isEmptyRow) {
        worksheet[cell_ref].s = {
          fill: { fgColor: { rgb: 'FFB6C1' } }, // Rosa claro
          border: borderStyle,
        };
      } else {
        // Linhas normais de dados - só aplica estilo se não foi aplicado acima (linha rosa)
        if (!worksheet[cell_ref].s || !worksheet[cell_ref].s.fill) {
          worksheet[cell_ref].s = {
            alignment: { vertical: 'top', wrapText: true },
            border: borderStyle,
          };
        }
      }
    }
  }

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Agendamento');

  const doc = new jsPDF();

  doc.autoTable({
    body: rows,
    styles: {
      fontSize: 10,
      cellPadding: 2,
      valign: 'top',
      halign: 'left',
      overflow: 'linebreak',
      minCellHeight: 0,
      lineWidth: 0.1,
      lineColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [248, 204, 204],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center',
      valign: 'middle',
      lineWidth: 0.1,
      lineColor: 0,
    },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 20 },
      2: { cellWidth: 30 },
      3: { cellWidth: 25 },
      4: { cellWidth: 20 },
      5: { cellWidth: 30 },
      6: { cellWidth: 20 },
      7: { cellWidth: 25, halign: 'right' },
    },
    tableWidth: 'auto',
    didParseCell: function (data) {
      // garante borda
      data.cell.styles.lineWidth = 0.1;
      data.cell.styles.lineColor = [0, 0, 0];

      const rowRaw = data.row.raw;

      const isHeader = data.row.index === 0;

      // linha separadora: todas as células são string vazia
      const isSeparatorRow =
        Array.isArray(rowRaw) && rowRaw.every((cell) => cell === '');

      if (isHeader) {
        data.cell.styles.fillColor = [248, 204, 204];
        data.cell.styles.textColor = 0;
        data.cell.styles.fontStyle = 'bold';
        data.cell.styles.halign = 'center';
        data.cell.styles.valign = 'middle';
      } else if (isSeparatorRow) {
        data.cell.styles.fillColor = [255, 182, 193]; // rosa claro
      } else {
        data.cell.styles.fillColor = [255, 255, 255]; // branco
      }
    },
  });
  doc.save('Delivery agendamento.pdf');
  const excelData = XLSX.write(workbook, { type: 'buffer' });

  return excelData;
}
